module.exports = __webpack_public_path__ + "static/img/female-bg-tr.5969db09.png";